import { Card, Flex, Loader } from '@mantine/core';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/elements/Button';
import DataTable from '../../components/elements/DataTable';
import Text from '../../components/fields/Text';
import EmptySyncStock from '../../components/fragments/EmptySyncStock';
import IcRefresh from '../../components/icons/IcRefresh';
import IcSync from '../../components/icons/IcSync';
import IcUpdateStock from '../../components/icons/IcUpdateStock';
import { AppContext } from '../../contexts';
import { useDebounce } from '../../utils/hooks';
import { fetchSyncStockMerchant, fetchUpdateStockMerchant } from './actions';
import { statusFile, typestock } from './constants';
import styles from './styles.scoped.css';

export default function UpdateStockMerchant() {
  const { setBreadcrumbs } = useContext(AppContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [afterSync, setAfterSync] = useState(false);
  const inputRef = useRef(null);
  const debouncedSearch = useDebounce(search, 1000);
  const {
    dataUpdateStock: { data, meta }, isLoadingUpdateStock,
    dataSyncUpdateStock, isLoadingSyncUpdateStock, id
  } = useSelector((state) => state.updateStockMerchant);

  useEffect(() => {
    setBreadcrumbs(['Update Stok Pangkalan']);
  }, []);

  const getUpdateStockMerchant = () => {
    dispatch(fetchUpdateStockMerchant(1, ''));
  };
  useEffect(() => {
    getUpdateStockMerchant();
  }, []);

  useEffect(() => {
    if (afterSync && !isLoadingSyncUpdateStock && dataSyncUpdateStock) {
      getUpdateStockMerchant();
      setAfterSync(false);
    }
  }, [isLoadingUpdateStock, dataSyncUpdateStock]);

  useEffect(() => {
    dispatch(fetchUpdateStockMerchant(1, debouncedSearch));
  }, [debouncedSearch]);

  const column = [
    {
      heading: 'Tanggal Update',
      value: 'createdAt',
    },
    {
      heading: 'Nama File',
      value: 'fileName',
      className: styles['namefileColumn'],
    },
    {
      heading: 'Tipe Stok',
      value: ({ type }) => typestock[`${type}`],
    },
    {
      heading: <Button onClick={getUpdateStockMerchant} style={'transparent'}>Status <IcRefresh classname={'icon'} /></Button>,
      value: ({ status }) => statusFile[`${status}`],
    },
    {
      heading: 'Action',
      value: (val) => (renderAction(val))
    }
  ];


  const renderAction = (val) => {
    const isLoadingbtn = val.status === 2 ||
      (isLoadingSyncUpdateStock && id === val.historyId);
    const isDisabled = val.status !== 1 ||
      (isLoadingSyncUpdateStock && id === val.historyId);
    return (
      <Button disabled={isDisabled}
        icon={<IcSync classname={isDisabled && 'iconDisable'} />}
        onClick={handledSync(val.historyId)} size={'small'}>
        {isLoadingbtn ? <Loader color="gray" size="sm" /> :
          'Sync Data'}
      </Button >
    );
  };

  const handledSync = (id) => () => {
    dispatch(fetchSyncStockMerchant(id, setAfterSync(true)));
  };

  const buttonUploadClicked = () => {
    navigate('/merchant/update-stock-merchant/upload');
  };

  return (
    <div>
      <Card className={styles.containerSearch} withBorder>
        <Flex align="center" justify="space-between" w="100%">
          <div>
            <Button className={styles.btnIcon} onClick={buttonUploadClicked} >
              <IcUpdateStock className={styles['whiteIcon']} /> Unggah Data Stok Pangkalan
            </Button>
          </div>
          <div className={styles.rightSection}>
            <Button className={styles.btnIcon} onClick={getUpdateStockMerchant} outlined>
              <IcSync classname={styles.icon} /> Perbarui Data
            </Button>
            <Text
              className={styles['search-bar']}
              disabled={isLoadingUpdateStock}
              hideLabel
              inputProps={{
                ref: inputRef,
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => {
                  setSearch(e.target.value);
                }
              }}
            />
          </div>
        </Flex>
      </Card>
      {data.length === 0 ? (
        <EmptySyncStock />
      ) :
        <Card className={styles.table} withBorder>
          <div className={styles['table-container']} >
            <DataTable
              column={column}
              data={data}
              endTreshould={200}
              loading={isLoadingUpdateStock}
              meta={meta}
              onEndReached={() => {
                !isLoadingUpdateStock && dispatch(fetchUpdateStockMerchant(meta.page + 1, ''));
              }}
              withIndex
            />
          </div>
        </Card>
      }
    </div>
  );
}
